'use client';

import { useState } from 'react';

interface EntityLogoProps {
  src: string;
  alt: string;
  size?: number;
  fallbackEmoji: string;
}

export function EntityLogo({ src, alt, size = 24, fallbackEmoji }: EntityLogoProps) {
  const [error, setError] = useState(false);

  if (error) {
    return (
      <span
        aria-label={alt}
        style={{
          display: 'inline-block',
          verticalAlign: 'middle',
          width: size,
          height: size,
          lineHeight: `${size}px`,
          textAlign: 'center',
          fontSize: size * 0.75,
        }}
      >
        {fallbackEmoji}
      </span>
    );
  }

  const logoAlt = alt && !alt.toLowerCase().includes('logo') ? `${alt} logo` : alt;

  return (
    <img
      src={src}
      alt={logoAlt}
      width={size}
      height={size}
      loading="lazy"
      style={{ display: 'inline-block', verticalAlign: 'middle' }}
      onError={() => setError(true)}
    />
  );
}
